import { FormGroup } from "@angular/forms";


export const trimFgEmptyControls = (fg: FormGroup): Object => {
    return Object.fromEntries(Object.entries(fg.getRawValue()).filter(([_, v]) => v != null && v !== ''))
  };
  